import { render } from "./Natures.vue?vue&type=template&id=17718296&scoped=true"
import script from "./Natures.vue?vue&type=script&lang=js"
export * from "./Natures.vue?vue&type=script&lang=js"

import "./Natures.vue?vue&type=style&index=0&id=17718296&scoped=true&lang=css"

import exportComponent from "D:\\JOSE\\Escritorio\\Proyectos VUE\\canal-denuncias\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17718296"]])

export default __exports__